/**
 * @author zk
 * @description 记录用户页面配置
 * @Date 2019/12/28
 */
import React from 'react'
import { component_tool, framework_tool } from '../../../tool';
import {Divider} from "antd";
let { WizModal } = component_tool;

//配置项
let componentName = 'authUserLog'
const columns = [
  {
    name: "id",
    fromItem: {
      type: "hidden"
    }
  },
  {
    title: "用户账号",
    name: "userName",
    searchItem: {},
    tableItem: {
      width: 150
    },
    formItem: {
      rules: [{
        required: true,
        message: '请选择用户账号'
      }],
    },
  },
  {
    title: "事件",
    name: "event",
    dataIndex: "event",
    tableItem: {},
    dict: [
      { code: '登出', codeName: '登出' },
      { code: '登录', codeName: '登录' }
    ],
    searchItem: {
      type: 'select'
    }
  },
  {
    title: "记录时间",
    name: "createTime",
    tableItem: {
      width: 150
    }
  },
  {
    title: "详细信息",
    name: "description",
    tableItem: {
      width: 150
    }
  },
  {
    title: "访问源IP地址",
    name: "address",
    searchItem: {},
    tableItem: {
      width: 150
    },
    formItem: {
      rules: [{
        required: true,
        message: '请输入访问源IP地址'
      }]
    },
  },
  {
    title: "访问类型",
    name: "strSource",
    tableItem: { width: 150},
  },
  {
    title: "访问类型",
    name: "source",
    dict: [
      { code: '0', codeName: '移动课堂ANDROID' },
      { code: '1', codeName: '移动课堂IOS' },
      { code: '2', codeName: '培训助手' },
      { code: '3', codeName: 'PC管理' },
      { code: '4', codeName: 'PC学员' },
      { code: '5', codeName: 'PC' },
      { code: '6', codeName: 'APP' },
    ],
    searchItem: {
      type: 'select'
    },
    formItem: {
      rules: [{
        required: true,
        message: '请输入访问类型'
      }]
    },
  },
];
const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  // export: {
  //   path: `${componentName}/export`,
  //   payload: {
  //     key: `${componentName}@export`,
  //     apiParams: {}
  //   }
  // }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
